import { CheckCircle2, AlertTriangle } from "lucide-react";

const USES = [
  ["Advanced analytics", "Potential payment option for deeper wallet and cluster analysis."],
  ["Developer API access", "Potential method to access higher API tiers once the API exists."],
  ["Community participation", "Potential involvement in feature priorities and dataset labelling."],
];

export const TokenPlanned = () => (
  <section id="token" className="scroll-mt-20 border-b border-trace-line bg-trace-panel py-24 lg:py-32" data-testid="token-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-wrap items-center gap-3">
        <p className="eyebrow">04 — $TRACE</p>
        <span data-testid="token-status-badge" className="inline-flex items-center gap-1.5 rounded-full border border-trace-green/40 bg-trace-green/10 px-3 py-1 font-mono text-[11px] uppercase tracking-wider text-trace-green">
          <CheckCircle2 size={12} /> Launched
        </span>
      </div>
      <h2 className="mt-4 max-w-3xl text-3xl font-semibold tracking-[-0.02em] text-white sm:text-4xl">$TRACE is live. Described honestly.</h2>
      <p className="mt-5 max-w-2xl text-base leading-relaxed text-trace-muted">
        $TRACE has launched on Solana. Its utility inside the TRACE platform is still in development: the uses below are
        planned, have not yet been implemented or verified, and may change.
      </p>
      <div className="mt-12 grid gap-5 md:grid-cols-3">
        {USES.map(([t, d], i) => (
          <div key={t} className="rounded-xl border border-dashed border-trace-line bg-trace-bg/60 p-6" data-testid={`token-use-${i}`}>
            <p className="font-mono text-[11px] uppercase tracking-wider text-trace-dim">Potential use</p>
            <h3 className="mt-3 text-lg font-medium text-white">{t}</h3>
            <p className="mt-2 text-sm text-trace-muted">{d}</p>
          </div>
        ))}
      </div>
      <div className="mt-8 flex flex-col gap-5 rounded-xl border border-trace-green/25 bg-trace-card p-6 sm:flex-row sm:items-center sm:justify-between" data-testid="token-official-source">
        <div>
          <p className="eyebrow text-trace-green">Official contract address</p>
          <p className="mt-2 max-w-xl text-sm text-trace-muted">
            The $TRACE contract address (CA) is published only on our official X account. Any address not posted there is not affiliated with TRACE.
          </p>
        </div>
        <a href="https://x.com/TraceForSolana" target="_blank" rel="noopener noreferrer" data-testid="token-x-link"
          className="inline-flex shrink-0 items-center gap-2.5 rounded-full border border-trace-green/40 bg-trace-green/10 px-5 py-2.5 text-sm font-medium text-trace-green transition-colors duration-200 hover:bg-trace-green hover:text-trace-bg">
          <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
          @TraceForSolana
        </a>
      </div>
      <div role="note" data-testid="token-disclaimer" className="mt-4 flex items-start gap-3 rounded-xl border border-amber-500/30 bg-amber-500/5 p-5 text-sm text-amber-100/90">
        <AlertTriangle size={18} className="mt-0.5 shrink-0 text-amber-400" />
        <p>
          The token is live, but its platform utility is still planned. It has no in-app utility today and offers no staking rewards. Always verify the
          contract address on @TraceForSolana before interacting, and treat any other address claiming to be $TRACE as unverified.
        </p>
      </div>
    </div>
  </section>
);
